export default __webpack_public_path__ + "static/media/DensoWave.23839aef.svg";